﻿import $ from "jquery";
import "ElementQueries";

import Microsoft365 from "./Microsoft365";
import Microsoft365PromoTwentyDollars from "./Microsoft365PromoTwentyDollars";
import Microsoft365PromoExtraTime from "./Microsoft365PromoExtraTime"

export default function (options) {
	const $ep = $(`#${options.entryPointId}`);

	if ($ep.length === 0)
		return;

	const instance = !options.promo
		? new Microsoft365(options, $ep)
		: options.promo.type === "TwentyDollarsPromo"
			? new Microsoft365PromoTwentyDollars(options, $ep)
			: options.promo.type === "ExtraTimeOffer"
				? new Microsoft365PromoExtraTime(options, $ep)
				: new Microsoft365(options, $ep);

	$ep.data("microsoft365", instance);
}
